import { HockeyLesson } from '../@types';
import { RequestApi } from '../helpers';

const getHockeyLessons = async () => {
  const response = await RequestApi.get<HockeyLesson[]>(`/hockeylesson`);
  return response;
};

const createHockeyLessonBooking = async (userData: FormData) => {
  const response = await RequestApi.post(
    '/hockeyLesson/createLessonBooking',
    userData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const hockeyLessonService = {
  getHockeyLessons,
  createHockeyLessonBooking,
};

export default hockeyLessonService;
